'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInternalPubNubCommand = exports.getTimestampFromToken = exports.getPubNubConfigArguments = undefined;
exports.getLobbyChannel = getLobbyChannel;
exports.buildChannelFromUtkOrVid = buildChannelFromUtkOrVid;

var _immutable = require('immutable');

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _PubNubMessageTypes = require('conversations-schema/constants/PubNubMessageTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// pubnub time tokens are in 10^7 precision, but we want milliseconds
var PUBNUB_CONVERSION = 10000;

var PRESENCE_TIMEOUT = 60;
var HEARTBEAT_INTERVAL = 30;

var envSuffix = function envSuffix() {
  return _enviro2.default.getInternal('api') === 'qa' ? 'qa' : 'prod';
};

function getBaseChannel(_ref) {
  var _ref$primaryId = _ref.primaryId,
      primaryId = _ref$primaryId === undefined ? _hubspot2.default.get() : _ref$primaryId,
      secondaryId = _ref.secondaryId;

  return envSuffix() + '.messages.' + primaryId + '-' + secondaryId;
}

function getLobbyChannel() {
  return getBaseChannel({
    secondaryId: _hubspot2.default.get(),
    primaryId: 'lobby'
  });
}

function buildChannelFromUtkOrVid(userId, _ref2) {
  var messagesUtk = _ref2.messagesUtk,
      vid = _ref2.vid;

  var channelId = vid || messagesUtk;
  return getBaseChannel({ secondaryId: userId }) + '-' + channelId;
}

var getPubNubConfigArguments = exports.getPubNubConfigArguments = function getPubNubConfigArguments(chatConfig, uuid) {
  var logVerbosity = _enviro2.default.getInternal('api') === 'qa';
  return {
    publishKey: chatConfig.publishKey,
    subscribeKey: chatConfig.subscribeKey,
    authKey: chatConfig.authToken.token,
    uuid: uuid,
    logVerbosity: logVerbosity,
    channel: chatConfig.channels,
    presenceTimeout: PRESENCE_TIMEOUT,
    heartbeatInterval: HEARTBEAT_INTERVAL,
    restore: true
  };
};

var getTimestampFromToken = exports.getTimestampFromToken = function getTimestampFromToken(timeToken) {
  return Math.floor(timeToken / PUBNUB_CONVERSION);
};

var isInternalPubNubCommand = exports.isInternalPubNubCommand = function isInternalPubNubCommand(message) {
  var internalCommands = (0, _immutable.List)([_PubNubMessageTypes.CLOSE_CHANNEL, _PubNubMessageTypes.OPEN_CHANNEL, _PubNubMessageTypes.BLOCK]);

  return internalCommands.includes(message.type);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/utils/pubNubHelpers.js
// module id = 57
// module chunks = 0 1